// @ts-nocheck
/* eslint-disable */
/*
 * This file was automatically generated.
 * DO NOT MODIFY BY HAND.
 */

export default {
  $ref: './ModuleFederationPlugin.json#/definitions/ExternalsType',
} as const;
